/* eslint-disable */
import React from "react";
import { last, first } from 'lodash';
import { CalendarYear } from '../../../controls/CalendarYear';
import { useParameter } from "../../../shared";

export const CalendarControl: React.FC = () => {
    const [lastYear] = useParameter("@last_year");

    const set = (value: number | null | undefined) => {
         
        return value;
    };
    const change = (value: number | null | undefined) => {
         
        return value;
    };
    return <CalendarYear lastYear={lastYear} parameter="@calendar" dictionary="slides-calendar" onSet={set} onChange={change} />;
};
